export const GETTING_ON_AND_OFF_TIME = 180;
export const MAP_DIR_URL = 'https://www.google.com/maps/dir/?api=1';
export const MAP_SEARCH_URL =
  'https://www.google.com/maps/search/?api=1&query=';
